<template>
  <div>
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>

    <!-- 关键词检索  -->
    <div
      class="width100 margin-auto backwhite border-rd3 flex-betweenwrap"
      style="min-height: 72px"
      v-if="serchkey"
    >
      <el-form
        ref="ruleForm"
        size="small"
        label-width="80px"
        class="demo-ruleForm flexleft"
      >
        <el-form-item label="产品名称">
          <el-input placeholder="请输入产品名称" v-model="input"></el-input>
        </el-form-item>
        <el-form-item label="出售状态">
          <el-select
            v-model="sellzt"
            placeholder="请选择出售状态"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              class="width100"
              v-for="item in sellclass"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="估值状态">
          <el-select
            v-model="valuationzt"
            placeholder="请选择估值状态"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              class="width100"
              v-for="item in valuationclass"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div class="pad-left20">
          <el-button type="primary" @click="submitForm()">检 索</el-button>
          <el-button @click="resetForm()" class="resetbtn">重 置</el-button>
        </div>
      </el-form>
      <span
        class="
          attention
          margin-top10 margin-bot10 margin-left20 margin-right20
          f14
        "
        @click="toproductaddfication()"
        >新 增</span
      >
    </div>

    <el-skeleton
      class="width100 margin-top15"
      :loading="loading"
      animated
      :throttle="500"
      v-if="total != 0"
    >
      <template slot="template">
        <div class="width100 margin-auto backwhite border-rd3 alldigital">
          <div class="width100 margin-auto flexleft">
            <div
              class="width30 border-df border-rd3 margin-top20 margin-left20"
              style="padding: 10px; min-width: 500px"
              v-for="(item, index) in page"
              :key="index"
            >
              <div class="bordert-bf flex pad-bot10">
                <el-image
                  :src="
                    item.image == null || item.image == ''
                      ? ''
                      : item.image.indexOf('http') == -1
                      ? picturehead + item.image
                      : item.image
                  "
                  class="border-rd3 width30"
                  style="height: 100px"
                >
                  <div
                    slot="error"
                    class="image-slot textalign-center lineheight100 f22"
                    style="border: 1px solid #f0f0f0"
                  >
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div class="pad-left10 width70">
                  <p class="flex-between">
                    <span class="f18 fw600">{{ item.title }}</span
                    ><span class="f14" style="color: #e55343"
                      >估值:{{ item.amount }}万元</span
                    >
                  </p>
                  <p
                    class="f14 lineheight20 corlor93 margin-top5 overheighthide"
                    v-html="item.remark"
                  ></p>
                  <p class="bluecolor f14 margin-top10">
                    <span
                      v-for="(_item, _index) in item.tags"
                      :key="_index"
                      :class="_index != 0 ? 'pad-left5' : ''"
                      >#{{ _item }}</span
                    >
                  </p>
                </div>
              </div>
              <div class="pad-top10 flex-betweenNowrapAlign f14 cursorpointer">
                <div>
                  <span
                    @click="tovalueassessment(index)"
                    class="pad-left10"
                    style="color: #52c5cb"
                    >成果价值评估</span
                  >
                </div>
                <div>
                  <span style="color: #52c5cb" @click="Savechanges(index)"
                    >详情</span
                  >
                  <span
                    class="pad-left10"
                    style="color: #52c5cb"
                    @click="todetails(index)"
                    >修改</span
                  >
                  <span
                    class="pad-left10"
                    style="color: #52c5cb"
                    @click="removepro(index)"
                    >删除</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="total != 0"
            class="
              width98
              margin-auto
              flex-betweennowrap
              pad-top20 pad-bot20
              pagination
            "
          >
            <span></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </el-skeleton>
    <div
      class="width100 margin-auto backgroudFFF margin-top15"
      v-if="total == 0"
    >
      <el-empty
        :image="require('@/assets/barsvg/zwsj@3x.png')"
        :image-size="200"
        description="抱歉，没有搜到您想要的内容"
        class="heightempty"
        ><p style="position: relative; bottom: 60px" class="f14">
          暂无数据
        </p></el-empty
      >
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisiintroduction"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorbox"
    >
      <p class="textalign-left f18">成果估值委托</p>
      <div class="textalign-left margin-top30 pad-bot20">
        <div>
          <p class="margin-top20">委托需求</p>
          <el-input
            placeholder="请输入委托需求"
            v-model="guzgiremark"
            type="textarea"
            :autosize="autosize"
            class="inputDeep margin-top10"
            maxlength="500"
            rows="5"
            cols="20"
          >
          </el-input>
        </div>
      </div>
      <div class="but-box textalign-right">
        <el-button @click="dialogVisiintroduction = false">取 消</el-button>
        <el-button class="f14" type="primary" @click="guzhichange()">
          保 存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  entachievementsindex,
  entachievementsdelete,
} from "@/api/Center/Center.api";
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
import { entassessmentsave } from "@/api/business/business.api";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      loading: true,
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisiintroduction: false,
      serchkey: true,
      thisNum: 1,
      page: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      input: "",
      inputs: "",
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      guzhiid: "",
      guzgiremark: "",
      sellzt: "",
      sellclass: [
        {
          value: 0,
          label: "未委托出售",
        },
        {
          value: 1,
          label: "已委托出售",
        },
        {
          value: 2,
          label: "已出售",
        },
      ],
      valuationzt: "",
      valuationclass: [
        {
          value: 0,
          label: "未委托估值",
        },
        {
          value: 1,
          label: "已委托估值",
        },
        {
          value: 2,
          label: "已估值",
        },
      ],
    };
  },

  components: {
    callback,
    switchcore,
  },
  methods: {
    //   成果添加
    toproductaddfication() {
      this.$router.push({
        path: "/Results-trading/Results-add",
      });
    },

    removepro(index) {
      this.$confirm("此操作将删除此成果, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entachievementsdelete({ id: this.page[index].id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    // 修改
    todetails(index) {
      this.$router.push({
        path: "/Results-trading/Results-modify",
      });
      window.sessionStorage.setItem("Achievementnum", this.page[index].id);
    },

    //详情
    Savechanges(index) {
      window.sessionStorage.setItem("AchievementNamefujian", "first");
      window.sessionStorage.setItem("Achievementnum", this.page[index].id);
      BUS.$emit("Achievementnum", this.page[index].id);
      this.$router.push({
        path: "/Results-trading/Results-muchadd",
      });
    },
    // 价值评估
    tovalueassessment(index) {
      this.dialogVisiintroduction = true;
      this.guzhiid = this.page[index].id;
    },
    guzhichange() {
      entassessmentsave({
        achievements_id: this.guzhiid,
        remark: this.guzgiremark,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "提交成功",
            type: "success",
          });
          this.dialogVisiintroduction = false;
          this.$router.push({
            path: "/Results-trading/value-assessment",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 第一个分页
    currentchange(val) {
      this.thisNum = val;
      entachievementsindex({
        page: val,
        _keywords: this.input,
        sell: this.sellzt,
        valuation: this.valuationzt,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      entachievementsindex({
        page: 1,
        limit: val,
        _keywords: this.input,
        sell: this.sellzt,
        valuation: this.valuationzt,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // input重 置
    resetForm() {
      this.input = null;
      this.thisNum = 1;
      this.sellzt = "";
      this.valuationzt = "";
      entachievementsindex({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    submitForm() {
      entachievementsindex({
        _keywords: this.input,
        sell: this.sellzt,
        valuation: this.valuationzt,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      entachievementsindex({
        page: this.thisNum,
        _keywords: this.input,
        sell: this.sellzt,
        valuation: this.valuationzt,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });
    this.picturehead = window.g.Apisrc;
    this.Apisrc = window.g.ApiUrl + "/oss_form";

    entachievementsindex({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    BUS.$on("resultsadd", (data) => {
      if (data == "yess") {
        this.refresh();
        this.dialogVisibleadd = false;
        this.dialogVisiblemodify = false;
        this.$router.push({
          path: "/Results-trading/Results-muchadd",
        });
      } else {
        this.refresh();
        this.dialogVisibleadd = false;
        this.dialogVisiblemodify = false;
      }
    });
  },
};
</script>
<style scoped>
.hovercont:hover {
  background: #f7f9fc;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorboxs >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
.avatar-uploader {
  text-align: left;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 110px;
  height: 110px;
  line-height: 110px;
  /* text-align: center; */
  border: 1px dashed #e5e5e5;
}
.avatar {
  width: 110px;
  height: 110px;
  display: block;
}
/* 表单盒子 */
.but-box {
  width: 100%;
  margin: auto;
}
.buttonsure {
  background: #409eff;
  color: white;
  width: 80px;
  text-align: center;
  border-radius: 5px;
  line-height: 30px;
  float: right;
}
.box-right {
  width: 70%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}
.box-rights {
  width: 70%;
  font-size: 14px;
  position: relative;
}
::placeholder {
  color: #a4a4a4;
  font-size: 12px;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
}
</style>